// Volto's ContentMetadataTags only shares one image field (preview_image here,
// via Volto Light Theme). Hand it the first image the content has instead, so
// news items share their lead image.
// eslint-disable-next-line import/no-unresolved
import ContentMetadataTags from '@plone/volto-original/components/theme/ContentMetadataTags/ContentMetadataTags';
import { shareImage } from '../../../../../components/ShareImage/shareImage';

const ContentMetadataTagsWithShareImage = (props) => {
  const image = shareImage(props.content);
  const content =
    image && image !== props.content.opengraph_image
      ? { ...props.content, opengraph_image: image }
      : props.content;
  return <ContentMetadataTags {...props} content={content} />;
};

export default ContentMetadataTagsWithShareImage;
